import React, { Component } from "react";

import { Row, Col, Grid} from 'react-bootstrap';

import './Service.css';

class Service extends Component {
  render() {
    return (
      <Grid>
        <Row className="service-title" >
          <div>Interior design service package</div>
        </Row>
        <Row className="step-box">
          <Col xs={12}>
            <Col xs={12} md={4}>
              <div className="step">
                <div className="step-count">1</div>
                <div className="step-summary">SCHEMATIC DESIGN</div>
                <ul>
                  <li>Meet with team members</li>
                  <li>Concept and inspiration review</li>
                  <li>Design team drawing integration</li>
                  <li>Develop material selection</li>
                  <li>Budget allocation</li>
                </ul>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="step">
                <div className="step-count">2</div>
                <div className="step-summary">DESIGN DEVELOPMENT</div>
                <ul>
                  <li>Material selection for details for example: kitchen cabinet door color and style</li>
                  <li>Budget control for all the materials</li>
                  <li>Design development example: kitchen back splash pattern</li>
                  <li>Design detail drawing</li>
                </ul>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="step">
                <div className="step-count">3</div>
                <div className="step-summary">ADDITIONAL SERVICES</div>
                <ul>
                  <li>3D Modeling</li>
                  <li>Photo realistic rendering</li>
                  <li>Extra design consulting like art work, furniture, curtain selection.</li>
                  <li>Refer architect for permit drawing.</li>
                </ul>
              </div>
            </Col>
          </Col>
        </Row>
        <Row className="service-title">
          <div>Staging service package</div>
        </Row>
      </Grid>
    );
  }
}

export default Service;



// WEBPACK FOOTER //
// ./src/Service.js